import { useState } from 'react';
import KickImage from 'Reuseables/KickImage';
import { Modal } from 'react-bootstrap';
import { useHistory } from "react-router-dom";

/* ASSETS */
import CloseButton from "../../images/round-close-button.png"
import LogoKick from "../../images/authenticIconNoBG.png"

type ModalPenaltyAlertProps = {
  balance: any;
  urlAfterSuccessTopup: any;
  balance_with_fee: any;
  isOpen: boolean;
  onToggle: () => void;
  openTopupModal: () => void;
  doRefreshToken: () => void;
  successAction: () => void;
  settleWithKickCredit: () => Promise<any>;
  fetchProfile: () => Promise<any>;
  doGetData: () => Promise<any>;
};

const ModalPenaltyAlert = ({
  isOpen,
  onToggle,
  openTopupModal,
  balance,
  settleWithKickCredit,
  doRefreshToken,
  fetchProfile,
  doGetData,
  balance_with_fee,
  urlAfterSuccessTopup,
  successAction
}: ModalPenaltyAlertProps) => {
  const history = useHistory();
  const [process, setProcess] = useState(urlAfterSuccessTopup ? "success" : 'initial')
  const [submitting, setSubmitting] = useState(false)
  const isKickCreditEnough = parseInt(balance) > 0 && parseInt(balance) >= parseInt(balance_with_fee);

  return (
    <Modal centered className="modal-penalty-alert" show={isOpen} onHide={() => onToggle()}>
      <KickImage style={{ cursor: "pointer" }} className="close-btn" src={CloseButton} alt="..." onClick={() => onToggle()} />
      {process === 'initial' ? <div className="modal-penalty-content">
        <p className='title'>Hold on, you have a negative balance on your seller credit.</p>
        <p className='sub-title'>Please settle the amount to resume your selling activities</p>
        <div className="button-wrapper">
          <button className={`${(parseInt(balance) <= 0 || submitting) ? "disbaled" : ''}`} onClick={() => {
            if (parseInt(balance) >= 0 && !submitting) {
              setSubmitting(true)
              settleWithKickCredit()
                .then(() => {
                  setProcess("success")
                  setSubmitting(false)
                  doRefreshToken()
                  fetchProfile()
                  doGetData()
                })
                .catch(() => {
                  setSubmitting(false)
                  setProcess("initial")
                })
            }
          }}>Settle with Kick Credit</button>

          <button className={`${isKickCreditEnough ? "disbaled" : ""}`} onClick={() => {
            if (!isKickCreditEnough) {
              openTopupModal()
            }
          }}>Top Up Now</button>
        </div>
        <p className='last-text'>
          Why do i have a negative balance?
          <span style={{ cursor: "pointer" }} onClick={() => history.push("/helps/general-faq")}>Visit our link</span>
        </p>
      </div> : null
      }

      {
        process === 'success' ? <div className="modal-penalty-content success-wrapper">
          <KickImage onClick={() => onToggle()} src={LogoKick} alt="..." className='logo-kick' />
          <p className='title'>Thanks! Your settlement has been received.</p>
          <p className='sub-title success'>This completion allows you to resume your selling activities in Kick Avenue. To avoid future suspension, please pay more attention to your incoming sales ahead.</p>
          <button onClick={() => successAction()} className='button-success'>OK</button>
        </div> : null
      }
    </Modal >
  );
};

export default ModalPenaltyAlert;
